import type { EntityNames } from "../config";
import { EntitiesMap } from "../config";

export function getEntityType(entityName: EntityNames) {
  return EntitiesMap[entityName];
}

export function getEntityName(target: any) {
  return (Object.keys(EntitiesMap) as EntityNames[]).find(key => EntitiesMap[key] === target);
}
